import React from "react";
import Page from "../Components/Page";
import RequestPasswordResetForm from "../features/auth/RequestPasswordResetForm";
import { useTranslation } from "react-i18next";

export default function RequestPasswordReset() {
  const { t } = useTranslation();
  return (
    <Page title={t("Request Password Reset")}>
      <RequestPasswordResetForm />
    </Page>
  );
}
